import { openBiDirectionalChannel } from '../utils';
import { GET_PROCESS_FORMS } from '../constants';
var getProcessForms = (params, events, opportunityCode) => {
  openBiDirectionalChannel(params, {
    type: GET_PROCESS_FORMS,
    payload: {
      events,
      opportunityCode
    }
  });
};
export default getProcessForms;